<section class="socials-wrapper">
  <div *ngFor="let social of socials" class="social-item">
    <div class="social-icon-wrapper">
      <img src="{{ social.iconUrl }}" alt="{{ social.name }}" />
    </div>
    <p>
      <span>{{ social.name }}</span>
      <a href="{{ social.link }}" target="_blank" rel="noopener noreferrer"
        >Atrizult {{ social.name }}</a
      >
      <span></span>
    </p>
  </div>
</section>
